import React from 'react';
import CrudPage from '../../components/CrudPage';
import { sectionApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'id' },
  { header: 'Section Name', field: 'sectionName' },
];

const formFields = [
  { name: 'sectionName', label: 'Section Name', type: 'text', required: true },
];

const SectionPage = () => (
  <CrudPage
    title="Sections"
    subtitle="Manage tag sections"
    api={sectionApi}
    columns={columns}
    formFields={formFields}
    idField="id"
    searchField="sectionName"
  />
);

export default SectionPage;
